'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _textEllipsis = require('text-ellipsis');

var _textEllipsis2 = _interopRequireDefault(_textEllipsis);

var _qrcode = require('qrcode.react');

var _qrcode2 = _interopRequireDefault(_qrcode);

var _helpers = require('helpers');

var _components2 = require('components');

var _utils = require('helpers/utils');

require('./SlideWithQR.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SlideWithQR: {
        displayName: 'SlideWithQR'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/SliderWithQR/default/SlideWithQR.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MAX_TITLE_LENGTH = 20;

var SlideWithQR = _wrapComponent('SlideWithQR')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        currency: state.currency
    };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
    (0, _inherits3.default)(SlideWithQR, _React$Component);

    function SlideWithQR(props) {
        (0, _classCallCheck3.default)(this, SlideWithQR);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SlideWithQR.__proto__ || (0, _getPrototypeOf2.default)(SlideWithQR)).call(this, props));

        _this.renderQRCode = function () {
            if (__CLIENT__ && _this.props.product) {
                return _react3.default.createElement(_qrcode2.default, { value: window.location.origin + '/product/' + _this.props.product.id });
            }

            return null;
        };

        _this.state = {
            countForSendBasket: 1
        };
        return _this;
    }

    (0, _createClass3.default)(SlideWithQR, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                product = _props.product,
                currency = _props.currency;
            var id = product.id,
                price = product.price,
                name = product.name,
                pictures = product.pictures,
                description = product.description;

            price = parseFloat(price);
            var imgSrc = (0, _helpers.checkPicture)(pictures, true);

            return _react3.default.createElement(
                'div',
                { className: 'SlideWithQR u-full-height text-center', id: 'single-product' },
                _react3.default.createElement(
                    'div',
                    { className: 'product-item-holder size-big single-product-gallery u-full-height' },
                    _react3.default.createElement(_components2.ProductWishIcon, { product: product, inCard: true }),
                    _react3.default.createElement(
                        'div',
                        { id: 'owl-single-product', className: 'flying-to-cart-holder u-full-height' },
                        _react3.default.createElement(
                            'div',
                            { className: 'SlideWithQR__content' },
                            _react3.default.createElement(
                                'div',
                                { className: 'single-product-gallery-item big', id: 'slide1' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/product/' + id },
                                    _react3.default.createElement('img', { className: ' flying-to-cart-img', alt: '', src: imgSrc })
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'SlideWithQR__footer' },
                            _react3.default.createElement(
                                'div',
                                { className: 'container-fluid' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'row bottom-active' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'hidden-xs hidden-sm col-lg-3 col-md-3 qr-col' },
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'qr-wrapper' },
                                                this.renderQRCode()
                                            )
                                        ),
                                        _react3.default.createElement('div', { id: 'productName', className: 'col-xs-12 col-lg-6 col-md-4 product_title',
                                            dangerouslySetInnerHTML: { __html: (0, _utils.cutText)(name, MAX_TITLE_LENGTH) }
                                        }),
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-xs-12 visible-xs visible-sm' },
                                            this.renderQRCode()
                                        ),
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-lg-2 col-xs-12 col-md-4 col-sm-offset-0 col-md-offset-0 product_title' },
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'body-holder', id: 'active' },
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'body' },
                                                    _react3.default.createElement(
                                                        'div',
                                                        { className: 'prices' },
                                                        _react3.default.createElement(
                                                            'div',
                                                            { className: 'price-current' },
                                                            _react3.default.createElement(_components2.MoneyValue, {
                                                                value: price,
                                                                icon: currency.icon,
                                                                iconAfterValue: currency.icon_after_value
                                                            })
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 bottom-row' },
                                        _react3.default.createElement(
                                            'div',
                                            { id: 'addToBasketAndCount',
                                                className: 'col-xs-12 col-lg-offset-4 col-sm-offset-3 col-lg-8 col-md-6 col-md-offset-6 counter' },
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'body-holder', id: 'active' },
                                                _react3.default.createElement(_components2.QuantityProduct, {
                                                    value: this.state.countForSendBasket,
                                                    callback: function callback(newCount) {
                                                        _this2.setState({ countForSendBasket: newCount });
                                                    }
                                                }),
                                                _react3.default.createElement(_components2.AddToBasket, {
                                                    id: 'addto-cart',
                                                    product: product,
                                                    className: ['huge'],
                                                    style: { marginTop: '11px' },
                                                    count: this.state.countForSendBasket,
                                                    updateProducts: this.props.updateProducts
                                                })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SlideWithQR;
}(_react3.default.Component), _class2.propTypes = {
    product: _propTypes2.default.object,
    updateProducts: _propTypes2.default.func,
    currency: _propTypes2.default.object
}, _temp)) || _class));

exports.default = SlideWithQR;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderWithQR/default/SlideWithQR.jsx
// module id = 1769
// module chunks = 0